import { render, staticRenderFns } from "./VesselController.vue?vue&type=template&id=64fa781c&scoped=true"
import script from "./VesselController.vue?vue&type=script&lang=js"
export * from "./VesselController.vue?vue&type=script&lang=js"
import style0 from "./VesselController.vue?vue&type=style&index=0&id=64fa781c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fa781c",
  null
  
)

export default component.exports